import { createBrowserHistory } from '@core/navigation';

export const HISTORY = createBrowserHistory();
